import { render, staticRenderFns } from "./BlackInk.vue?vue&type=template&id=4b52c937&scoped=true&"
import script from "./BlackInk.vue?vue&type=script&lang=js&"
export * from "./BlackInk.vue?vue&type=script&lang=js&"
import style0 from "./BlackInk.vue?vue&type=style&index=0&id=4b52c937&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52c937",
  null
  
)

export default component.exports